import * as React from 'react';
import { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/selectors/UserSelectors';
import { paths } from '../../router';
import { Badge } from 'react-bootstrap';
import classNames from 'classnames';
import { TRootState } from "../../store/reducers/RootReducer";
import BasketPolicy from '../../policies/BasketPolicy';
import { UserType } from "../../entities/User";
import { OrderStatus, TApiOrder } from "../../api/endpoints/Order";
import OrderPolicy from "../../policies/OrderPolicy";
import * as Api from "../../api";
import { NavLink as RouterNavLink } from 'react-router-dom';

/**
 * Control for nav links
 */
const NavMenu: React.FC = () => {
  const user = useSelector(selectUser);
  const productCount = useSelector<TRootState, number>(state => Object.keys(state.basket.data).length);
  const [orders, setOrders] = useState<Array<TApiOrder> | null>(null);
  const pendingOrdersCount = orders?.length ?? 0;

  useEffect(() => {
    if (OrderPolicy.canViewPendingOrders(user)) {
      Api.Order.list({ status: OrderStatus.SUBMITTED, limit: 1000 })
        .then(response => {
          setOrders(response.results);
        });
    }
  }, [user]);

  return (
    <div className="navmenu">
      <NavLink text="Home" to={paths.root} />

      {
        BasketPolicy.canAccess(user) &&
        <NavLink
          text="Your basket"
          count={productCount}
          to={paths.basket}
        />
      }

      {
        user.type === UserType.Customer &&
        <NavLink
          text="Orders"
          to={paths.orders}
        />
      }

      {
        OrderPolicy.canViewPendingOrders(user) &&
        <NavLink
          text="Pending orders"
          count={pendingOrdersCount}
          to={paths.pendingOrders}
        />
      }

      {
        OrderPolicy.canViewCcpOrders(user) &&
        <NavLink
          text="CCP orders"
          to={paths.ccpOrders}
        />
      }

      {
        OrderPolicy.canViewPublicOrders(user) &&
        <NavLink
          text="Public orders"
          to={paths.publicOrders}
        />
      }

      {
        user.type !== UserType.Unknown &&
        <NavLink text="Area preset library" to={paths.areas} />
      }
    </div>
  );
};

type INavLinkProps = {
  text: ReactNode;
  to: string;
  count?: number;
  className?: string;
};

const NavLink = (props: INavLinkProps) => {
  const { className, text, to, count } = props;

  return (
    <RouterNavLink
      className={classNames("navline", className)}
      activeClassName="active"
      exact
      to={to}
    >
      {text}
      {
        Boolean(count) &&
        <Badge variant="primary">{count}</Badge>
      }
    </RouterNavLink>
  );
};

export default NavMenu;
